module.exports = __webpack_public_path__ + "112e09640e5811d963d04e44a0b92f4e.pdf";